<template>
    <form-controll :field="field">
        <template scope="api">
            <autosuggest :items="items" :select="select" :readonly="readonly" :value="api.getValue()" :name="field" @input="api.setValue" @blur="api.setTouched" :caption="caption" :label="label" :error="api.getTouched() ? api.getError() : undefined" :placeholder="placeholder" />
        </template>
    </form-controll>
</template>
<script>
import { FormControll } from '../../../../form/components';

export default {
    name: 'sign-form-select',
    props: {
        caption: String,
        label: String,
        placeholder: String,
        readonly: Boolean,
        select: Boolean,
        type: {
            type: String,
            default: 'text'
        },
        field: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    components: {
        FormControll,
    },
}
</script>


// WEBPACK FOOTER //
// FormSelect.vue?68023c7f